// e.g. "Mis à jour il y a 8 jours par Fabien FELIXINE".
//
// `by` is null when the log exists but its user could not be populated
// (e.g. a deleted account). We then show the wording without the author
// rather than "par undefined". Companies with no log entry at all — filled
// in before logging existed — are handled by the caller, not here.

const RELATIVE = new Intl.RelativeTimeFormat('fr', { numeric: 'auto' });

export const formatRelativeDay = (date) => {
  if (!date) return null;
  const days = Math.round((new Date(date) - new Date()) / 86400000);
  return RELATIVE.format(days, 'day');
};

export const formatLastUpdate = (entry) => {
  if (!entry?.at) return null;
  const when = formatRelativeDay(entry.at);
  if (!entry.by) return `Mis à jour ${when}`;
  return `Mis à jour ${when} par ${entry.by.firstname} ${(entry.by.lastname ?? '').toUpperCase()}`;
};
